import { observable } from '@legendapp/state';

type CashoutAnimationType = 'idle' | 'cashout';

type CashoutAnimationState = {
  animationType: CashoutAnimationType;
  setAnimationType: (animationType: CashoutAnimationType) => void;
  triggerAnimation: (
    animationType: CashoutAnimationType,
    duration?: number
  ) => void;
  cleanup: () => void;
};

let animationTimeout: ReturnType<typeof setTimeout> | undefined;

export const cashoutAnimationState$ = observable<CashoutAnimationState>({
  animationType: 'idle',
  setAnimationType: (animationType: CashoutAnimationType) => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
    }
    cashoutAnimationState$.animationType.set(animationType);
  },
  triggerAnimation: (animationType: CashoutAnimationType, duration = 2000) => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
    }
    cashoutAnimationState$.animationType.set(animationType);

    animationTimeout = setTimeout(() => {
      cashoutAnimationState$.animationType.set('idle');
    }, duration);
  },
  cleanup: () => {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
      animationTimeout = undefined;
    }
  },
});
